import { ThumbnailsHelper } from '../../helpers/ThumbnailsHelper';
export class ThumbnailErrorPresentationRenderer {
    constructor(assetViewerView) {
        this.assetViewerView = assetViewerView;
        this.image = null;
        this.isLoading = false;
        this.isActive = false;
        this.defaultThumb = this.assetViewerView.defaultThumb;
    }
    get hasMetaData() {
        return true;
    }
    get dimensions() {
        return { width: 400, height: 300 };
    }
    get url() {
        return this.assetViewerView.assetViewerItem.downloadUrl;
    }
    load() {
        return Promise.resolve();
    }
    render(container) {
        return Promise.resolve().then(() => {
            container.innerHTML = '';
            const fallbackImage = document.createElement('div');
            let defaultThumb = this.defaultThumb;
            if (defaultThumb.indexOf('raw.svg') !== -1) {
                defaultThumb = this.assetViewerView.config.DEFAULT_THUMB_BASE_PATH + ThumbnailsHelper.getDefaultThumb('document', null);
            }
            fallbackImage.style.width = '100%';
            fallbackImage.style.height = '100%';
            fallbackImage.style.backgroundImage = `url(${defaultThumb})`;
            fallbackImage.style.backgroundSize = '40%';
            fallbackImage.style.backgroundRepeat = 'no-repeat';
            fallbackImage.style.backgroundPosition = 'center';
            container.appendChild(fallbackImage);
        });
    }
    destroy() { }
    destroyFinal() { }
}
//# sourceMappingURL=ThumbnailErrorPresentationRenderer.js.map